import React from 'react';
import { Link } from 'react-router-dom';
import Tag from 'components/common/Tag';

const columns = [
  {
    title: '_id',
    dataIndex: '_id',
    key: '_id',
    render: _id => (
      <Link style={{ fontSize: 10 }} to={`/admin/users/${_id}`}>
        {_id}
      </Link>
    ),
  },
  {
    title: 'email',
    dataIndex: 'emails.0.address',
    key: 'emails.0.address',
  },
  {
    title: 'first',
    dataIndex: 'profile.firstName',
  },
  {
    title: 'last',
    dataIndex: 'profile.lastName',
  },
  {
    title: 'organizations',
    render: (text, { organizations }) => organizations.length
      ? organizations.map(item => (
        <Tag key={item._id} color="cyan">
          {item.title}
        </Tag>
      ))
      : null,
  },
  {
    title: 'role',
    dataIndex: 'roles',
    key: 'roles',
  },
];

export default columns;



// WEBPACK FOOTER //
// ./src/routes/admin-users/AdminUsersTable/columns.js